import { MerchantProduct } from "utils/URLs";
import { get, post, deleteApi } from "utils/v2/api";

export const createProduct = (data: any) => post(`${MerchantProduct}`, data);
export const getProduct = (data: any) => get(`${MerchantProduct}/${data}`);
export const removeProduct = (data: any) => {
  return deleteApi(`${MerchantProduct}/${data}`);
};
